/// <amd-module name="Wiki/Overview/Utils/WikiPageSwitchTtiLogger" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { Areas, PerformanceConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";

export class WikiPageSwitchTtiLogger {
    private _isScenarioStarted: boolean;
    private _performanceService: IVssPerformanceService;

    constructor(private readonly _pageContext: IVssPageContext) {
        this._performanceService = this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        this._isScenarioStarted = false;
    }

    public startScenario(): void {
        this._performanceService.startScenario(PerformanceConstants.Overview, true, undefined, { isFirstRender: false });
        this._isScenarioStarted = true;
    }

    public endScenario(): void {
        if (this._isScenarioStarted) {
            this._performanceService.endScenario(Areas.Wiki, PerformanceConstants.Overview, true);
            this._isScenarioStarted = false;
        }
    }
}
